import type { FC } from "react";

import type { BaseIconProps } from "@/assets/icons/utils";

export const IconOnaCopy: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M10.8333 13.5V5.16663H2.5V13.5H10.8333Z" stroke="currentColor" strokeLinecap="round" />
                    <path d="M10.8333 10.84H13.5V2.5H5.16663V5.16667" stroke="currentColor" strokeLinecap="round" />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path d="M10.8333 13.5V5.16663H2.5V13.5H10.8333Z" stroke="currentColor" strokeLinecap="round" />
                        <path d="M10.8333 10.84H13.5V2.5H5.16663V5.16667" stroke="currentColor" strokeLinecap="round" />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path d="M10.8333 13.5V5.16663H2.5V13.5H10.8333Z" stroke="currentColor" strokeLinecap="round" />
                        <path d="M10.8333 10.84H13.5V2.5H5.16663V5.16667" stroke="currentColor" strokeLinecap="round" />
                    </g>
                </svg>
            );
    }
};
